import React from 'react';

const HomeIcon = (props) => {
    return (
<svg viewBox="0 0 512 512" width="25px" height="25px" className={`lg:${props.hidden}`}>
<rect x="382.933" y="73.6" style={{fill:"#0967D2"}} width="58.667" height="102.4"/>
<rect x="360.533" y="21.333" style={{fill:"#0967D2"}} width="103.467" height="55.467"/>
<path style={{fill:"#9AA5B1"}} d="M44.8,276.267V512h418.133V276.267c-82.133-82.133-128-128-209.067-209.067l0,0
	C172.8,149.333,126.933,195.2,44.8,276.267z"/>
<path style={{fill:"#0967D2"}} d="M464,276.267c-82.133-82.133-128-128-209.067-209.067c-41.6,40.533-73.6,72.533-105.6,104.533
	s-64,64-104.533,104.533v48c82.133-82.133,128-128,209.067-209.067c82.133,82.133,128,128,209.067,209.067v6.4l0,0v-54.4H464z"/>
<path style={{fill:"#415A6B"}} d="M216.533,512H90.667V388.267c0-35.2,28.8-62.933,62.933-62.933l0,0c35.2,0,62.933,28.8,62.933,62.933
	V512z"/>
<rect x="253.867" y="325.333" style={{fill:"#344A5E"}} width="164.267" height="144"/>
<g>
	<rect x="270.933" y="342.4" style={{fill:"#8AD7F8"}} width="56.533" height="109.867"/>
	<rect x="344.533" y="342.4" style={{fill:"#8AD7F8"}} width="56.533" height="109.867"/>
</g>
<path style={{fill:"#0967D2"}} d="M502.4,232.533L279.467,9.6c-12.8-12.8-35.2-12.8-48,0L9.6,232.533c-12.8,12.8-12.8,35.2,0,48
	c12.8,12.8,35.2,12.8,48,0L256,82.133l198.4,198.4c12.8,12.8,35.2,12.8,48,0C515.2,266.667,515.2,245.333,502.4,232.533z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
    );
};

export default HomeIcon;